import React, { Component } from 'react';

export default class DateSelector extends Component {
	constructor(props){
		super(props);
		this.state={
			dates:[],
			selected: null
		}
	}

	componentDidMount() {
		this.setState({
			dates: this.props.dates,
			selected: this.props.selected
		})
	}

	componentWillReceiveProps(nextProps) {
  		if (nextProps.selected !== this.state.selected) {
    		this.setState({ selected: nextProps.selected });
  		}
	}


	//<!---------------------------- Calling Parent Method ----------------------------!>
	onDateSelection(dat) {
		this.setState({
			selected: dat
		})
		this.props.dateSelected(dat);
	}	

	//<!---------------------------- Populating dates ----------------------------!>
	getDates() {
		var data = this.props.dates.map((dat, index) => {
			return <li className="dropdown-data" key={index} onClick={() => this.onDateSelection(dat)}>{dat.deliveryDate}</li>
		})
		return data;
	}

	render() {
		return(<div>
				<div className={"dropdown "+this.props.classes}>
					<div className="pull-right drop-arrow dropdown-toggle" data-toggle="dropdown">
						<i className="fas fa-angle-down eighteen-font"></i>
					</div>
					<div className="pull-right drop-date drop-date-wider" data-toggle="dropdown" style={{textAlign:'left'}}>
						{(this.state.selected) ? <div>{this.state.selected.deliveryDate}</div> : <div>Delivery Date</div>}
					</div>
					<ul className="dropdown-menu">
				  		{this.getDates()}
				    </ul>
				</div>
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/commons/DateSelector.js